import React from 'react';
import {OrbitComponent} from '../base-components/orbit-component/orbit-component';
import {observer} from 'mobx-react';

export const BreadcrumbsComponent = observer(class BreadcrumbsComponent extends OrbitComponent<{}> {

  render() {
    if(!this.services.configuration.data.generalSettings.showBreadcrumbs
        ||  this.services.device.hybrid.isEmbedded
        || this.services.location.isHomePage
        || this.services.cmsPages.currentPage) {
      return null;
    }

    return (
      <div className={'app-breadcrumbs'}>
        <div className={'breadcrumbs-container'}>
          <div className={'breadcrumbs-links'} itemScope={true} itemType={'http://schema.org/BreadcrumbList'}>
            {this.services.siteMap.breadcrumbs.map((bcrumb, index) => bcrumb.render(index + 1))}
          </div>
        </div>
      </div>
    );
  }
});
